module.exports = __webpack_public_path__ + "img/logo_text.3eec8089.png";